import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "form__datepicker-item is-daterange" };
const _hoisted_2 = { class: "form__label-wrapper" };
const _hoisted_3 = ["for"];
const _hoisted_4 = { class: "form__datepicker-wrapper" };
const _hoisted_5 = ["id", "name", "data-js-datetyp", "value", "placeholder"];
import { useI18n } from "../features/useI18n";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DateFilterInput',
    props: {
        item: {}
    },
    emits: ['update:text'],
    setup(__props) {
        const { t } = useI18n();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("label", {
                        for: _ctx.item.id,
                        class: "form__datepicker-label"
                    }, _toDisplayString(_unref(t)(_ctx.item.label)), 9 /* TEXT, PROPS */, _hoisted_3)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("input", {
                        autocomplete: "off",
                        type: "text",
                        "data-js-item": "js-form-datepicker",
                        class: "form__datepicker-text",
                        id: _ctx.item.id,
                        name: _ctx.item.id,
                        "data-js-datetyp": _ctx.item.datetype,
                        value: _ctx.item.value,
                        placeholder: _unref(t)(_ctx.item.placeholder),
                        onChange: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:text', $event.target.value)))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_5)
                ])
            ]));
        };
    }
});
